import { useContext, useState } from 'react';
import { Dialog, DialogTitle, Typography, Box, DialogContent, DialogActions, Button, Grid, FormControlLabel, Checkbox } from '@material-ui/core';
import { usersContext } from 'views/Users/UsersContext';
import { CognitoStatus } from 'helpers/enums';
import { Alert } from '@material-ui/lab';
import { DeleteIconButton } from 'components';


let DeleteUser = () => {
    let { user, deleteRequest, updateDeleteRequest, deleteUser } = useContext(usersContext);

    let [deleteManagerIsOpen, setDeleteManagerIsOpen] = useState(false);

    let openDeleteManager = () => {
        updateDeleteRequest({
            email: user?.email || '',
            deleteUserRegistrations: true,
            deleteWarrantyProfile: user?.foundInWarranty === true,
            deleteCognitoUsers: !(user?.cognitoStatus !== CognitoStatus.NotFound && user?.foundInWarranty === true)
        });

        setDeleteManagerIsOpen(true);
    }


    return (
        <>
            <DeleteIconButton onClick={openDeleteManager} />


            <Dialog open={deleteManagerIsOpen} fullWidth maxWidth="lg">
                <DialogTitle disableTypography id="alert-dialog-title">
                    <Typography variant="h3">
                        <Box fontWeight="fontWeightLight">
                            Deleting user {user?.email}
                        </Box>
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Grid container>
                        <Grid item xs>
                            <FormControlLabel
                                label="Delete user profile in Warranty"
                                disabled
                                control={
                                    <Checkbox
                                        checked={deleteRequest.deleteWarrantyProfile}
                                        onChange={(e: any) => updateDeleteRequest({
                                            ...deleteRequest,
                                            deleteWarrantyProfile: e.target.checked
                                        })}
                                    />
                                }
                            />
                        </Grid>

                        <Grid item xs>
                            <FormControlLabel
                                label="Delete user account in Cognito"
                                disabled={user?.cognitoStatus === CognitoStatus.NotFound || user?.foundInWarranty === false}
                                control={
                                    <Checkbox
                                        checked={deleteRequest.deleteCognitoUsers}
                                        onChange={(e: any) => updateDeleteRequest({
                                            ...deleteRequest,
                                            deleteCognitoUsers: e.target.checked
                                        })}
                                    />
                                }
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControlLabel
                                label="Delete product registrations in Warranty (product registrations contains only user email)"
                                control={
                                    <Checkbox
                                        checked={deleteRequest.deleteUserRegistrations}
                                        onChange={(e: any) => updateDeleteRequest({
                                            ...deleteRequest,
                                            deleteUserRegistrations: e.target.checked
                                        })}
                                    />
                                }
                            />
                        </Grid>


                        <Grid item xs={12}>
                            <Alert severity='info'>
                                <Typography>
                                    If you proceed&nbsp;
                                    {user?.foundInWarranty === true && deleteRequest.deleteCognitoUsers && 'user account in Cognito and Warranty profile will be deleted.'}
                                    {user?.foundInWarranty === false && deleteRequest.deleteCognitoUsers && 'user account in Cognito will be deleted.'}
                                    {user?.foundInWarranty === true && deleteRequest.deleteCognitoUsers === false && 'user profile in Warranty will be deleted.'}
                                    {deleteRequest.deleteUserRegistrations === true && ' All product registrations will be deleted'}
                                </Typography>
                            </Alert>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={() => setDeleteManagerIsOpen(false)}>
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={async () => {
                            let res = await deleteUser();
                            if (res === true)
                                setDeleteManagerIsOpen(false);
                        }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default DeleteUser;